import { render, staticRenderFns } from "./modal-password.vue?vue&type=template&id=e5e725f8"
import script from "./modal-password.vue?vue&type=script&lang=js"
export * from "./modal-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports